/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SuccessorChangeLogHistoryTypeDto = {
    ColourUpdate: 'COLOUR_UPDATE',
    ExclamationMarkUpdate: 'EXCLAMATION_MARK_UPDATE',
    EmployeeCommentUpdate: 'EMPLOYEE_COMMENT_UPDATE',
    CareerPathUpdate: 'CAREER_PATH_UPDATE',
    CareerPathAdd: 'CAREER_PATH_ADD',
    CareerPathDelete: 'CAREER_PATH_DELETE',
    ExpatUpdate: 'EXPAT_UPDATE',
    ExcommUpdate: 'EXCOMM_UPDATE'
} as const;

export type SuccessorChangeLogHistoryTypeDto = typeof SuccessorChangeLogHistoryTypeDto[keyof typeof SuccessorChangeLogHistoryTypeDto];



